export default {
  // 공통
  common: {
    back: '뒤로',
    confirm: '확인',
    continue: '계속',
    cancel: '취소',
    retry: '재시도',
    total: '합계',
    profile: '마이페이지',
    history: '기록',
    pleaseLogin: '로그인해주세요',
    my: '마이',
    appName: 'AI 스마트 주문',
    loading: '로딩 중...',
    lang: '언어 선택',
    loadFailed: '로딩 실패',
    operationFailed: '작업 실패',
    notSet: '미설정',
    country: '국가',
    all: '전체',
    searchPlaceholder: '검색',
    noMore: '더 이상 없습니다'
  },

  // 홈
  home: {
    allFoods: '전체 음식',
    headline: {
      sub: '당신이 몰랐던',
      main: '{country} 미식'
    },
    articleTag: '가이드',
    localGuideTitle: '현지 여행 가이드',
    recommendedArticlesAll: '전체',
    hotTopics: '인기 음식 테마',
    orderCallout: '이제 "이거 이거" 주문은 그만!',
    mustEatBadge: '필수 맛집',
    countrySelect: {
      eyebrow: '여행 목적지',
      title: '국가 선택',
      subtitle: '적합한 음식 영감과 가이드를 매칭해 드립니다',
      footer: '왼쪽 상단에서 언제든지 변경 가능'
    },
    loadCountriesFailed: '국가 로딩 실패'
  },

  // 즐겨찾기
  favorites: {
    title: '즐겨찾기',
    empty: '즐겨찾기 없음',
    foods: '음식',
    articles: '가이드'
  },

  articleList: {
    title: '{country} 가이드',
    empty: '추천 가이드가 없습니다'
  },

  // 메뉴 상세
  dishDetail: {
    quantity: '수량',
    introduction: '메뉴 소개',
    loadingIntroduction: '메뉴 소개를 가져오는 중...',
    getIntroduction: '메뉴 소개 보기',
    addToCart: '장바구니 담기 ({count}개)',
    selectQuantity: '수량 선택',
    addedToCart: '장바구니에 {count}개 담았습니다',
    loadFailed: '메뉴 소개 가져오기 실패',
    noImage: '이미지 없음',
    imageSearchEmpty: '정확히 일치하는 음식 이미지가 없습니다',
    imageSearchAction: '이미지 검색',
    aiImageGenerating: 'AI 이미지 생성 중',
    generating: '생성 중'
  },

  // 탭바
  tabbar: {
    home: '홈',
    cameraOrder: '촬영 주문',
    favorites: '즐겨찾기',
    profile: '마이',
    camera: '촬영',
    menu: '메뉴'
  },

  // 카메라
  camera: {
    translate: '번역 언어',
    takeOrUpload: '탭하여 촬영 또는 업로드',
    uploadHint: '최대 9장까지 업로드 가능',
    addMore: '계속 추가',
    order: '주문 시작',
    selectLanguage: '번역 언어 선택',
    singleMode: '단일 모드',
    multiMode: '다중 모드',
    history: '기록',
    takePhotoError: '촬영 실패, 다시 시도해주세요',
    cameraUnsupported: '카메라 기능을 지원하지 않습니다',
    cameraPermissionDenied: '카메라 권한이 없습니다. 설정에서 허용해주세요',
    capture: '계속 촬영',
    tapToCapture: '터치하여 촬영',
    tapToStart: '터치하여 촬영 시작',
    readyToCapture: '메뉴판 촬영',
    uploading: '업로드 중...',
    uploadFailed: '업로드 실패',
    pleaseCapture: '사진을 먼저 촬영해주세요',
    maxPhotosReached: '최대 9장까지 촬영 가능합니다',
    photosAdded: '{count}장 추가됨',
    confirmUpload: '업로드 확인',
    uploadMessage: '{count}장의 사진을 업로드하여 메뉴를 인식합니다',
    startRecognition: '인식 시작',
    confirmRecognition: '인식 확인',
    willRecognize: '{count}장의 메뉴 사진을 인식합니다',
    continueShooting: '계속 촬영',
    prepareUpload: '업로드 준비 중...',
    compressingImage: '이미지 압축 중...',
    compressionFailed: '압축 실패',
    useOriginal: '원본 사용',
    takePhoto: '터치하여 촬영',
    selectFromGallery: '앨범에서 선택',
    operationFailed: '작업 실패, 다시 시도해주세요',
    processingPhoto: '사진 처리 중...',
    leavingPageWarning: '사진 처리 중입니다. 정말 나가시겠습니까?',
    restoreInfoMissing: '이전 {count}장의 사진 정보를 감지했으나 이미지 데이터가 손실되었습니다. 다시 촬영해주세요',
    addedAndSkipped: '{added}장 추가, 이미지 파일이 아닌 {skipped}장 건너뜀',
    remainingQuotaNotice: '{phone}님: 구독 유효 기간: {days}',
    guide: {
      step1: '메뉴판 촬영',
      step2: 'AI 인식 및 번역',
      step3: '메뉴 생성'
    }
  },

  // 로그인
  login: {
    title: '로그인',
    phone: '휴대폰 번호',
    code: '인증번호',
    phoneNumber: '휴대폰 번호',
    verifyCode: '인증번호',
    sendCode: '인증번호 발송',
    resend: '재발송',
    login: '로그인',
    loggingIn: '로그인 중...',
    success: '로그인 성공',
    failed: '로그인 실패, 잠시 후 다시 시도해주세요',
    loginSuccess: '로그인 성공',
    loginFailed: '로그인 실패',
    phonePlaceholder: '휴대폰 번호 입력',
    codePlaceholder: '인증번호 입력',
    phoneRequired: '휴대폰 번호를 입력해주세요',
    codeRequired: '인증번호를 입력해주세요',
    phoneInvalid: '휴대폰 번호 형식이 올바르지 않습니다',
    codeInvalid: '인증번호는 4-6자리 숫자입니다',
    phoneError: '휴대폰 번호 형식이 올바르지 않습니다',
    codeError: '인증번호 형식이 올바르지 않습니다',
    codeSent: '인증번호가 발송되었습니다',
    resendCode: '재발송',
    countdown: '{count}초 후 재시도',
    retryAfter: '{seconds}초 후 재시도',
    tooFrequent: '발송이 너무 잦습니다. 잠시 후 다시 시도해주세요',
    dailyLimit: '일일 발송 한도 초과',
    sendFailed: '발송 실패, 잠시 후 다시 시도해주세요',
    agreeTips: '로그인 시 이용약관 및 개인정보처리방침에 동의하게 됩니다'
  },

  // 메뉴
  menu: {
    title: '메뉴',
    cartTitle: '장바구니',
    checkout: '주문하기',
    totalItems: '총 {count}개',
    clearCart: '장바구니 비우기',
    emptyCart: '장바구니가 비었습니다',
    aiRecommend: 'AI 추천',
    addToCart: '장바구니 담기',
    viewDetail: '상세 보기',
    price: '가격',
    quantity: '수량',
    currentMenu: '현재 메뉴',
    clearCartConfirm: '장바구니를 비우시겠습니까?',
    noMenuData: '메뉴판을 먼저 촬영해주세요',
    confirmButton: '확인',
    cancelButton: '취소',
    hint: '알림',
    noMenuItemsFound: '인식된 메뉴 항목이 없습니다'
  },

  // AI 추천
  ai: {
    recommendedSets: '추천 세트',
    dishCount: '가지 요리',
    selectSetHint: '추천 세트를 선택해주세요',
    noSelectedDishes: '먼저 요리를 선택해주세요',
    setPrefix: '세트',
    others: '기타',
    diningOptions: '식사 선호',
    numberOfPeople: '인원수',
    dietaryPreferences: '식이 선호',
    budgetRange: '예산 범위',
    getRecommendation: 'AI가 추천해요',
    noSpicy: '매운 음식 제외',
    vegetarian: '채식',
    seafood: '해산물',
    meat: '육류',
    loading: '추천 생성 중...',
    recommendationTitle: 'AI 추천',
    tastePreference: '맛 선호',
    budgetPerPerson: '인당 예산',
    allergyWarning: '식이 제한(알레르기)',
    sweet: '단맛',
    sour: '신맛',
    spicy: '매운맛',
    bitter: '쓴맛',
    umami: '감칠맛',
    light: '담백함',
    heavy: '진한 맛',
    dairy: '유제품',
    eggs: '난류',
    fish: '생선',
    shellfish: '갑각류',
    treeNuts: '견과류',
    peanuts: '땅콩',
    wheat: '밀',
    soy: '대두',
    selectOptions: '식사 선호를 선택해주세요',
    peopleCountError: '인원수는 1명 이상이어야 합니다',
    budgetRangeError: '예산 범위는 양의 정수여야 합니다',
    budgetMaxMinError: '최대 예산은 최소 예산보다 크거나 같아야 합니다',
    submitFailed: '제출 실패, 다시 시도해주세요',
    minBudget: '최소 예산',
    maxBudget: '최대 예산',
    to: '~',
    yuan: '위안',
    recommendProgress: 'AI 추천 진행',
    analyzing: '메뉴 분석 중...',
    generating: '추천안 생성 중...',
    recommendReason: '추천 이유',
    menuCombination: '메뉴 조합',
    dietaryNotes: '식이 조언',
    servingSize: '권장 인분',
    viewDetail: '상세',
    goToCheckout: '주문하기',
    dish: '인분',
    menuOption: '세트',
    recommendedDishes: '추천 요리',
    categoryDishes: '분류별 요리',
    order: '주문',
    orderConversation: '주문 대화'
  },

  // 업로드
  upload: {
    title: '인식 중',
    uploading: '업로드 중...',
    recognizing: '메뉴 인식 중...',
    translating: '번역 중...',
    generating: '결과 생성 중...',
    complete: '인식 완료',
    failed: '인식 실패',
    progress: '진행',
    detailsTitle: '인식 상세',
    retake: '다시 촬영',
    retryUpload: '업로드 재시도',
    buyBenefits: '혜택 업그레이드',
    uploadingNow: '업로드 중',
    aiRecognizingImages: 'AI 이미지 인식 중',
    aiTranslatingMenu: 'AI 메뉴 번역 중',
    dynamicCompression: '이미지 동적 압축 중',
    ocrEngineIntegration: 'OCR 이미지 인식 엔진 연동',
    agentEngineBoot: '에이전트 엔진 시작',
    llmContextParsing: 'LLM 문맥 분석',
    ragTargetLanguage: 'RAG 대상 언어 매칭',
    cuisineRegionMapping: '요리 지역 매핑',
    enhancedTranslation: '향상된 번역 시작',
    dishMetadataClassification: '요리 메타데이터 분류',
    semanticUiConstruction: '의미론적 UI 구성',
    confirmCancelTitle: '취소 확인',
    confirmCancelMessage: '인식을 취소하시겠습니까?',
    preparingCount: '{count}장의 사진 준비 중...',
    startUploadCount: '{count}장의 사진 업로드 시작',
    processingComplete: '처리 완료',
    navigatingSoon: '이동 중...',
    processingCompleteAndNavigate: '처리 완료, 이동합니다',
    createBackgroundTask: '백그라운드 작업 생성 중...',
    noPhotoFound: '사진 데이터를 찾을 수 없습니다',
    pleaseRetake: '돌아가서 다시 촬영해주세요',
    dataParseFailed: '데이터 해석 실패',
    photoDataParseFailed: '사진 데이터 해석 실패',
    photoDataFormatError: '사진 데이터 형식 오류, 다시 촬영해주세요',
    uploadFailedShort: '업로드 실패',
    failedShort: '실패',
    errorTryAgain: '처리 실패, 다시 시도해주세요',
    menuNotFound: '메뉴를 인식하지 못했습니다. 다시 촬영해주세요',
    otherLlmErr: '메뉴 번역 실패',
    finalizing: '메뉴 번역 마무리 중',
    almostDone: '곧 완료됩니다, 잠시만 기다려주세요'
  },

  // 에러
  error: {
    network: '네트워크 오류, 연결을 확인해주세요',
    server: '서버 오류, 잠시 후 다시 시도해주세요',
    timeout: '요청 시간 초과, 다시 시도해주세요',
    unknown: '알 수 없는 오류',
    auth: '인증 실패, 다시 로그인해주세요',
    selectImage: '이미지 파일을 선택해주세요',
    imageTooLarge: '이미지는 20MB를 초과할 수 없습니다',
    processPhotoFailed: '사진 처리 실패, 다시 시도해주세요',
    processFileFailed: '파일 처리 실패',
    pageStateError: '페이지 상태 이상, 다시 촬영해주세요',
    processingPhotos: '사진 처리 중입니다. 잠시만 기다려주세요...',
    livePhotoNotSupported: '일반 사진을 선택해주세요. Live Photo는 지원하지 않습니다',
    microphonePermissionDenied: '마이크 권한이 거부되었습니다. 브라우저 설정에서 허용해주세요',
    microphoneNotFound: '마이크 장치를 찾을 수 없습니다',
    microphoneInUse: '마이크가 다른 앱에서 사용 중입니다',
    microphoneConfigNotSupported: '마이크가 요청된 구성을 지원하지 않습니다',
    recordingNotSupported: '브라우저가 녹음 기능을 지원하지 않습니다',
    recordingError: '녹음 중 오류가 발생했습니다',
    forbidden: '접근 권한이 없습니다',
    notFound: '요청한 리소스를 찾을 수 없습니다',
    requestFailed: '요청 실패',
    configError: '요청 설정 오류'
  },

  // 주문 대화
  orderConversation: {
    title: '주문 대화',
    menu_order: '주문',
    quantity: '수량',
    translatedText: '번역 텍스트',
    orderText: '주문 텍스트',
    userSpeak: '길게 눌러 말하기',
    waiterSpeak: '길게 눌러 말하기',
    customerSpeak: '길게 눌러 말하기',
    waiterSpec: '종업원',
    customerSpec: '고객',
    dish_detail: '상세',
    recording: '녹음 중...',
    common_confirm: '확인',
    customerRecording: '고객 녹음 중...',
    recognizing: '인식 중...',
    translating: '번역 중...',
    recordingFailed: '녹음 실패, 마이크 권한을 확인해주세요',
    recognitionFailed: '음성 인식 실패',
    translationFailed: '번역 실패',
    recognitionResult: '인식 결과',
    blankAudio: '말하는 시간이 너무 짧습니다',
    noDishes: '선택한 요리가 없습니다',
    assistantIntro:
      '안녕하세요. 저는 고객님의 주문을 돕는 앱입니다. 고객님이 아래 메뉴를 주문하려고 합니다. 궁금한 점이 있으면 하단 버튼을 길게 눌러 말씀해 주세요. 번역해서 전달하겠습니다.'
  },

  // 프로필
  profile: {
    title: '마이',
    memberCard: {
      title: '회원 혜택',
      dynamicTitle: '현재 {status} 사용자이며<br />이용 가능한 회원 혜택:',
      feature1: ' 메뉴 정밀 인식',
      feature2: ' 20개 이상의 언어 번역',
      feature3: ' AI 추천 주문',
      feature4: ' 다국적 요리 소개',
      feature5: ' 연속 음성 대화 번역',
      featureUsageTemplate: '{feature} (유효 {count})',
      unlock: '즉시 잠금 해제',
      unlockBenefits: '혜택 업그레이드'
    },
    menu: {
      privacy: '개인정보처리방침',
      terms: '이용약관',
      feedback: '피드백',
      serviceStatus: '서비스 상태',
      about: '소개'
    },
    redeem: {
      button: '혜택 교환',
      title: '혜택 교환',
      description: '교환 코드를 입력하여 혜택을 활성화하세요.',
      placeholder: '교환 코드 입력',
      helper: '문자 A-Z와 숫자 0-9를 지원합니다. 공백은 자동 제거되며 대소문자를 구분하지 않습니다.',
      submit: '즉시 교환',
      cancel: '취소',
      success: '교환 성공, 혜택이 갱신되었습니다',
      validation: {
        empty: '교환 코드를 입력해주세요',
        length: '교환 코드는 문자와 숫자가 포함된 12자여야 합니다',
        format: '교환 코드 형식이 잘못되었습니다. 확인 후 다시 시도해주세요',
        checksum: '교환 코드 검증 실패. 확인 후 다시 시도해주세요'
      }
    },
    register: '계정 탈퇴',
    registerHint: '탈퇴 기능 개발 중',
    logout: '로그아웃',
    logoutConfirm: {
      title: '로그아웃',
      message: '정말 로그아웃 하시겠습니까?'
    },
    logoutSuccess: '로그아웃되었습니다'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: 'AI 주문 혜택 잠금 해제',
    columns: {
      feature: '비교 목록'
    },
    plans: {
      freeUser: '무료 사용자',
      trial: '무료 체험',
      trialTag: '한정 기간 체험',
      oneDay: '1일 구독 패키지',
      twoDay: '2일 이용 패키지',
      threeDay: '3일 이용 패키지',
      fiveDay: '5일 이용 패키지'
    },
    actions: {
      tryNow: '체험하기',
      purchase: '구매하기',
      continueTrial: '계속 체험',
      trialUnavailable: '체험 종료',
      renew: '즉시 갱신',
      subscribed: '구독 중'
    },
    features: {
      validity: '남은 유효기간',
      price: '가격',
      usageCount: '혜택 횟수',
      aiTranslate: 'AI 메뉴 번역',
      aiTextDetail: '요리 상세\n텍스트판',
      aiRecommend: 'AI 추천 주문',
      aiOrder: 'AI 주문 보조',
      aiVoice: '음성 대화 번역'
    },
    values: {
      days: '{count}일',
      lifetime: '평생',
      free: '0',
      price: '{amount} 위안(CNY)',
      times: '{count} 회',
      notAvailable: '-',
      comingSoon: '- (순차 오픈 예정)'
    },
    remarkTitle: '혜택 설명',
    remarksText:
      '1. 메뉴 인식 번역 지원 국가: 아시아: 일본, 한국, 태국, 베트남, 싱가포르, 말레이시아, 인도네시아, UAE, 튀르키예; 유럽: 영국, 프랑스, 독일, 오스트리아, 스위스, 이탈리아, 아일랜드, 스페인, 포르투갈, 러시아, 체코, 헝가리, 크로아티아, 네덜란드, 루마니아, 스웨덴; 북미: 미국, 캐나다, 멕시코; 남미: 브라질, 아르헨티나, 칠레, 우루과이, 파라과이, 콜롬비아, 베네수엘라, 파나마, 페루, 에콰도르; 기타: 호주, 뉴질랜드.' +
      '\n참고: 스위스는 독/불/이탈리아어, 오스트리아는 독일어, 남미(브라질 제외)는 스페인어를 지원합니다.' +
      '\n2. 당사는 페이지 표시 내용 및 규칙에 대한 해석 권한을 가지며, 해석은 법률 및 규정을 준수하고 사용자의 합법적 권익을 보호합니다.',
    toast: {
      trialRedirect: '전체 체험 활성화를 위해 이동합니다',
      purchaseRedirect: '혜택 구매를 위해 이동합니다',
      contactAdmin: '관리자에게 연락하여 회원 서비스를 개통하세요',
      noQuota: '이용 횟수가 한도에 도달했습니다. "마이" 페이지에서 혜택을 구매해주세요',
      subscriptionExpired: '회원 혜택이 만료되었거나 횟수가 소진되었습니다. "마이" 페이지에서 갱신해주세요',
      trialExhausted: '체험 횟수가 소진되었습니다. "마이" 페이지에서 회원 혜택을 구매해주세요',
      wechatRequired: '결제는 위챗 내부 브라우저를 이용해주세요',
      paySuccess: '결제 성공, 혜택이 갱신되었습니다',
      payCancelled: '결제가 취소되었습니다',
      payFailed: '결제 실패, 잠시 후 다시 시도해주세요',
      payPending: '결제 결과를 확인 중입니다. 나중에 주문 상태를 확인해주세요',
      productUnavailable: '현재 구매할 수 없는 상품입니다. 잠시 후 다시 시도해주세요'
    },
    currentBenefits: '현재 패키지',
    moreDetails: '상세',
    remainingBenefits: '잔여',
    totalBenefits: '합계',
    expireTime: '만료일',
    tabs: {
      compare: '비교',
      detail: '상세'
    },
    upgradeTitle: '혜택 업그레이드',
    trialNoteTitle: '체험 혜택 설명',
    trialNoteText: '체험 회원은 메뉴 번역 등 기능을 체험할 수 있습니다. 체험 기간은 구독 혜택에 영향을 주지 않습니다.',
    statusDetail: {
      title: '플랜 상세',
      planName: '플랜명',
      startTime: '시작일',
      expireTime: '종료일',
      totalCount: '총 횟수',
      status: '상태',
      statusMap: {
        pending: '활성화 대기',
        active: '사용 중',
        invalid: '만료됨/무효'
      }
    },
    durations: {
      oneDay: '1일',
      twoDay: '2일',
      threeDay: '3일',
      fiveDay: '5일'
    },
    subscriptionSuffix: '구독',
    subscriptionName: '{duration}구독',
    fiveDayDesc: '5일 유효',
    validityOnly: '{duration} 유효',
    validityAndUsage: '{duration} 유효, {usage} 이용 혜택 포함',
    usageCountSimple: '사용 횟수'
  }
}
